export const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  fade: true,
};
export const sliderStyles = {
  slideBg: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    height: "800px",
  },
  title: {
    fontSize: 80,
    color: "white",
    textAlign: "center",
  },
  subTitle: { fontSize: 50, color: "white", textAlign: "center" },
};

export const mainStyles = {
  box: { mt: "5rem", minHeight: "500px" },
};
